import { useSession } from 'next-auth/react'

import { getUserId } from '@/helpers/getUserId'
import { useCurrentCart } from '@/hooks/useCurrentCart'
import { useSiteContext } from '@/hooks/useSiteContext'

import type { GetCartRequest, GetUserRequest } from '@/gen/ecom/apis'

export function useBaseRequest() {
  const { data: session } = useSession()
  const { getBaseSiteId } = useSiteContext()

  const { current: cartId } = useCurrentCart()
  const baseSiteId = getBaseSiteId()

  const userId = getUserId(session)

  return {
    cartBaseRequest: { baseSiteId, cartId, userId } as GetCartRequest,
    userBaseRequest: { baseSiteId, userId } as GetUserRequest,
  }
}
